export const fmt = (
    v: number | null | undefined,
    digits: number = 2
): string => {
    if (v === null || v === undefined || Number.isNaN(v)) return '—';
    return Number(v).toFixed(digits);
};

export const fmtTime = (ms: number | null): string => {
    if (ms === null || ms === undefined) return '—';
    const d = new Date(ms);
    return d.toISOString().replace('T', ' ').replace('Z', ' UTC');
};

export const fmtDuration = (sec: number | null): string => {
    if (sec === null || Number.isNaN(sec)) return '—';
    const s = Math.abs(sec);
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = (s % 60).toFixed(1);
    return (
        (sec < 0 ? '-' : '') +
        (h ? h + 'h ' : '') +
        (m || h ? m + 'm ' : '') +
        r +
        's'
    );
};

export const fmtKm = (meters: number): string => (meters / 1000).toFixed(3);

export const fmtKmh = (mps: number | null): string => {
    if (mps === null) return '—';
    return (mps * 3.6).toFixed(2);
};
